if (!customElements.get("pcard-swatch")) {
  // mesmas larguras do srcset que o card monta no Liquid
  const CARD_IMAGE_WIDTHS = [165, 360, 535, 750, 940, 1100];

  class ProductCardColorSwatch extends HTMLElement {
    constructor() {
      super();

      this.selectors = {
        container: "[data-pcard-variant-picker]",
        optionNodes: [".m-product-option--node__label"],
        featuredImage: ".m-product-card__main-image",
        pcard: ".m-product-card",
        variantDropdown: ".m-product-option--dropdown-select",
        priceWrapper: ".m-price",
        unitPrice: ".m-price__unit",
        soldOutBadge: ".m-product-tag--soldout",
        saleBadge: ".m-product-tag--sale"
      };
      this.container = this.closest(this.selectors.container);
      this.pcard = this.closest(this.selectors.pcard);
      this.variantIdNode = this.pcard && this.pcard.querySelector('[name="id"]');
      this.featuredImage = this.pcard && this.pcard.querySelector(this.selectors.featuredImage);
      this.domNodes = queryDomNodes(this.selectors, this.pcard);
      this.colorMedia = this.readColorMedia();
      this.hasSecondImage = Boolean(this.pcard && this.pcard.classList.contains("m-product-card--show-second-img"));
      this.initializeData();
    }

    // Fotos de cada cor (principal e hover) que o product-card-6.liquid deixa no card
    readColorMedia() {
      const json = this.pcard && this.pcard.querySelector("[data-bs-color-media]");
      if (!json) return null;
      try {
        return JSON.parse(json.textContent);
      } catch (e) {
        return null;
      }
    }

    get disableSelectedVariantByDefault() {
      return this.dataset.disableSelectedVariantByDefault === "true";
    }

    async initializeData() {
      this.variantData = this.fetchVariantData();
      this.productHandle = this.container.dataset.productHandle;
      this.productData = await this.fetchProductJson();
      this.activeOptionNodeByPosition = {};
      this.hideUnavailableProductOptions = MinimogSettings.hide_unavailable_product_options;

      const { variantIdNode, productData, productData: { variants } = {} } = this;

      if (productData) {
        let currentVariantId = variantIdNode && Number(variantIdNode.value);
        if (!currentVariantId) {
          currentVariantId =
            productData.selected_or_first_available_variant && productData.selected_or_first_available_variant.id;
        }
        const currentVariant = variants.find((v) => v.id === currentVariantId) || variants[0];
        this.productData.initialVariant = currentVariant;
        if (!this.productData.selected_variant && variantIdNode && variantIdNode.dataset.selectedVariant) {
          this.productData.selected_variant = variants.find(
            (v) => v.id === Number(variantIdNode.dataset.selectedVariant)
          );
        }

        if (!this.disableSelectedVariantByDefault) {
          this.updateOptionsByVariant(currentVariant);
          this.updateQuickBuySizes();
          this.updateProductImage(currentVariant);
          // a cor escolhida depois, e nao a inicial: este evento dispara a cada
          // imagem que carrega na pagina e desfazia a troca de cor do card
          window.MinimogEvents.subscribe("m:image-loaded", () => {
            this.updateProductImage(this.currentVariant || currentVariant);
          });
        } else {
          // O card 6 ja sai com a cor da variante do card marcada no Liquid.
          // Registrada aqui, a troca de cor desmarca a anterior e a barra de
          // tamanhos passa a refletir a disponibilidade dessa cor.
          const preselected = (this.domNodes.optionNodes || []).filter((node) => node.dataset.selected === "true");
          if (preselected.length) {
            preselected.forEach((node) => {
              this.activeOptionNodeByPosition[node.dataset.optionPosition] = node;
            });
            this.currentVariant = currentVariant;
            this.updateQuickBuySizes();
          }
        }
      }

      if (this.domNodes.optionNodes) {
        this.domNodes.optionNodes.forEach((node) =>
          node.addEventListener("click", this.handleVariantSelection.bind(this))
        );
      }
      if (this.domNodes.variantDropdown) {
        this.domNodes.variantDropdown.addEventListener("change", this.handleVariantSelection.bind(this));
      }
    }

    fetchVariantData() {
      if (!this.variantData) {
        var jsonElement = this.container && this.container.querySelector('[type="application/json"]');
        this.variantData = JSON.parse(jsonElement ? jsonElement.textContent : "{}");
      }
      return this.variantData;
    }

    fetchProductJson() {
      var productUrl = `${window.MinimogSettings.routes.root}/products/${this.productHandle}.js`;
      productUrl = productUrl.replace("//", "/");
      return fetch(productUrl).then(function (response) {
        return response.json();
      });
    }

    toggleOptionNodeActive(optNode, active) {
      if (!optNode) return;
      if (active) {
        const { optionPosition, value: optionValue } = optNode.dataset;
        this.activeOptionNodeByPosition[optionPosition] = optNode;

        switch (optNode.tagName) {
          case "INPUT":
            optNode.checked = true;
            optNode.dataset.selected = "true";
            break;
          case "OPTION":
            optNode.dataset.selected = "true";
            const select = optNode.closest("select");
            if (select) select.value = optNode.value;
            break;
          case "LABEL":
            optNode.dataset.selected = "true";
            break;
          default:
            if (!optNode.classList.contains("m-product-quickview-button")) {
              console.warn("Unable to activate option node", optNode);
            }
            break;
        }

        this.updateSoldOutBadge(this.getVariantsByOptionValue(optionValue));
      } else {
        if (!["default", "image", "color"].includes(optNode.dataset.optionType)) {
          optNode.style.border = "";
        }
        optNode.checked = false;
        delete optNode.dataset.selected;
        const select = optNode.closest("select");
        if (select) select.value = "";
      }
    }

    updateOptionsByVariant(variant) {
      Object.values(this.activeOptionNodeByPosition).forEach((optNode) => this.toggleOptionNodeActive(optNode, false));

      const { optionNodes } = this.domNodes;
      const { options = [] } = variant || {};
      options.forEach((option, index) => {
        const optPosition = index + 1;
        optionNodes.forEach((optNode) => {
          const _optPosition = Number(optNode.dataset.optionPosition);
          const _optValue = optNode.dataset.value;

          if (_optPosition === optPosition && option === _optValue) {
            this.toggleOptionNodeActive(optNode, true);
          }
        });
      });
      this.updatePrice(variant);
    }

    getVariantFromActiveOptions = () => {
      const {
        productData,
        productData: { initialVariant },
        activeOptionNodeByPosition,
      } = this;
      const initialVariantOptions = {
        1: initialVariant.option1,
        2: initialVariant.option2,
        3: initialVariant.option3,
      };

      Object.values(activeOptionNodeByPosition).forEach((optNode) => {
        const { optionPosition, value } = optNode.dataset;
        initialVariantOptions[optionPosition] = value;
      });

      var options = Object.values(initialVariantOptions).filter(Boolean);
      var variant = getVariantFromOptionArray(productData, options);
      if (!variant && this.hideUnavailableProductOptions) {
        options.pop();
        variant = getVariantFromOptionArray(productData, options);
        if (!variant) {
          options.pop();
          variant = getVariantFromOptionArray(productData, options);
        }
      }
      this.currentVariant = variant;
      return variant;
    };

    handleVariantSelection(e) {
      var target = e.target;
      var newVariant;

      if (target.classList.contains("combined-variant")) {
        const variantId = Number(e.target.value);
        newVariant =
          this.productData && this.productData.variants && this.productData.variants.find((v) => v.id === variantId);
      } else {
        if (target.tagName === "SELECT") {
          target = target.querySelectorAll("option")[target.selectedIndex];
        }
        if (!target.classList.contains("m-product-option--node__label")) {
          target = target.closest(".m-product-option--node__label");
          if (!target) console.error("Unable to find option node!");
        }
        const { optionPosition } = target.dataset;

        const currActiveOptNode = this.activeOptionNodeByPosition[optionPosition];
        this.toggleOptionNodeActive(currActiveOptNode, false);
        this.toggleOptionNodeActive(target, true);
        newVariant = this.getVariantFromActiveOptions();

        // "Cor nova + tamanho de antes" pode estar esgotada: o card mostra a
        // variante disponivel mais barata dessa cor, que e a que o link abre na PDP
        if (!newVariant || !newVariant.available) {
          newVariant = this.getAvailableVariantForActiveOptions() || newVariant;
          this.currentVariant = newVariant;
        }
      }

      if (!newVariant) return;

      const { variantIdNode } = this;
      if (variantIdNode) {
        variantIdNode.setAttribute("value", String(newVariant.id));
        variantIdNode.value = String(newVariant.id);
      }

      this.updateBySelectedVariant(newVariant);
      this.updateSaleBadge(newVariant);
      this.updateQuickBuySizes();
    }

    getAvailableVariantForActiveOptions() {
      const { productData: { variants = [] } = {}, activeOptionNodeByPosition } = this;
      const activeNodes = Object.values(activeOptionNodeByPosition);
      const matches = (variant) =>
        activeNodes.every((node) => variant.options[Number(node.dataset.optionPosition) - 1] === node.dataset.value);

      const available = variants.filter((variant) => variant.available && matches(variant));
      if (!available.length) return variants.find(matches) || null;
      return available.reduce((best, variant) => (variant.price < best.price ? variant : best));
    }

    updateBySelectedVariant(variant) {
      if (variant) {
        this.updateProductImage(variant);
        this.updatePrice(variant);
        this.updateProductLinks(variant);
      }
    }

    // O link do card leva a variante escolhida: a PDP abre na mesma cor e com o
    // mesmo preco que o card mostrava
    updateProductLinks(variant) {
      if (!this.pcard) return;
      this.pcard.querySelectorAll("a.m-product-card__link, a.m-product-card__name").forEach((link) => {
        const url = new URL(link.getAttribute("href"), window.location.origin);
        url.searchParams.set("variant", variant.id);
        link.setAttribute("href", url.pathname + url.search + url.hash);
      });
    }

    updateQuickBuySizes() {
      const sizeButtons = this.pcard && this.pcard.querySelectorAll(
        ".m-product-card__size[data-size-option-position][data-size-option-value]"
      );

      if (!sizeButtons || !sizeButtons.length) return;

      sizeButtons.forEach((button) => {
        const variant = this.getVariantForQuickBuySize(
          Number(button.dataset.sizeOptionPosition),
          button.dataset.sizeOptionValue
        );
        const isAvailable = variant && variant.available;

        if (isAvailable) {
          button.dataset.variantId = String(variant.id);
          button.classList.remove("m-product-card__size--unavailable");
          button.removeAttribute("aria-disabled");
        } else {
          delete button.dataset.variantId;
          button.classList.add("m-product-card__size--unavailable");
          button.setAttribute("aria-disabled", "true");
        }
      });
    }

    getVariantForQuickBuySize(sizeOptionPosition, sizeValue) {
      const {
        productData,
        productData: { initialVariant },
        activeOptionNodeByPosition,
      } = this;

      if (!productData || !initialVariant || !sizeOptionPosition || !sizeValue) return null;

      const optionsByPosition = {
        1: initialVariant.option1,
        2: initialVariant.option2,
        3: initialVariant.option3,
      };

      Object.values(activeOptionNodeByPosition).forEach((optNode) => {
        const { optionPosition, value } = optNode.dataset;
        optionsByPosition[optionPosition] = value;
      });

      optionsByPosition[sizeOptionPosition] = sizeValue;
      return getVariantFromOptionArray(productData, Object.values(optionsByPosition).filter(Boolean));
    }

    updateProductCardSoldOutBadge(variant) {
      if (this.domNodes.soldOutBadge) {
        this.domNodes.soldOutBadge.style.display = variant.available ? "none" : "flex";
      }
    }

    updateSoldOutBadge(variants) {
      const soldOut = !variants.some((variant) => variant.available);
      if (this.domNodes.soldOutBadge) {
        this.domNodes.soldOutBadge.style.display = soldOut ? "flex" : "none";
      }
    }

    updateSaleBadge(variant) {
      if (!variant || !this.domNodes.saleBadge) return;

      const moneyFormat = window.MinimogSettings.money_format;
      const saleBadgeType = this.pcard.dataset.saleBadge

      const { compare_at_price, price } = variant;

      if (!compare_at_price || compare_at_price <= price) {
        this.domNodes.saleBadge.classList.add('!m:hidden');
        return;
      }

      this.domNodes.saleBadge.classList.remove('!m:hidden');

      let discount = compare_at_price - price;

      if (saleBadgeType === 'show_percentage') {
        discount = Math.round(discount / compare_at_price * 100);
        this.domNodes.saleBadge.innerHTML = `-${discount}%`;

      } else if (saleBadgeType === 'show_fixed_amount') {
        const saved = this.domNodes.saleBadge.querySelector('.m-currency--saved');
        discount = Math.round(discount);
        if (saved) {
          saved.innerHTML = formatMoney(discount, moneyFormat);
        }
      }
    }

    getVariantsByOptionValue = (value) => {
      const { productData: { variants } = {} } = this;
      return variants.filter((variant) => variant.options.includes(value));
    };

    updateProductImage(variant) {
      const colorMedia = this.getColorMedia(variant);
      if (colorMedia && colorMedia.main) {
        this.swapCardImage(this.featuredImage, colorMedia.main, colorMedia.alt);

        // o hover mostra a segunda foto da cor escolhida; sem ela, nao mostra
        // nenhuma (antes aparecia a segunda foto da cor inicial)
        const hoverImage = this.pcard.querySelector(".m-product-card__hover-image");
        if (hoverImage && colorMedia.hover) this.swapCardImage(hoverImage, colorMedia.hover);
        if (this.hasSecondImage) {
          this.pcard.classList.toggle("m-product-card--show-second-img", Boolean(hoverImage && colorMedia.hover));
        }
        return;
      }

      const src = variant && variant.featured_image && variant.featured_image.src;
      const { featuredImage } = this;
      const img = featuredImage && featuredImage.querySelector("img");

      if (img && src) {
        img.src = `${src}&width=533`;
        img.removeAttribute("srcset");
      }
    }

    getColorMedia(variant) {
      if (!this.colorMedia || !variant) return null;
      const node = this.domNodes.optionNodes && this.domNodes.optionNodes[0];
      const position = node ? Number(node.dataset.optionPosition) : 1;
      return this.colorMedia[variant.options[position - 1]] || null;
    }

    // Troca a foto mantendo o srcset e avisa o <responsive-image>: ele guarda o
    // src do HTML e o reaplica quando a imagem entra na tela, entao uma cor
    // escolhida antes do lazy load voltava para a foto inicial.
    swapCardImage(wrapper, url, alt) {
      const img = wrapper && wrapper.querySelector("img");
      if (!img || !url) return;

      const sized = (width) => `${url}${url.includes("?") ? "&" : "?"}width=${width}`;
      const src = sized(CARD_IMAGE_WIDTHS[CARD_IMAGE_WIDTHS.length - 1]);
      if (img.getAttribute("src") === src) return;

      img.srcset = CARD_IMAGE_WIDTHS.map((width) => `${sized(width)} ${width}w`).join(", ");
      img.src = src;
      if (alt) img.alt = alt;

      const responsiveImage = img.closest("responsive-image");
      if (responsiveImage) responsiveImage.src = src;
    }

    updatePrice(variant) {
      const classes = {
        onSale: "m-price--on-sale",
        soldOut: "m-price--sold-out",
      };

      const moneyFormat = window.MinimogSettings.money_format;

      const { priceWrapper, unitPrice } = this.domNodes;
      const { compare_at_price, price, unit_price_measurement } = variant;
      const onSale = Boolean(compare_at_price && compare_at_price > price);
      const soldOut = !variant.available;

      if (this.pcard) this.pcard.classList.toggle("m-product-card--onsale", onSale);

      if (onSale) {
        priceWrapper && priceWrapper.classList.add(classes.onSale);
      } else {
        priceWrapper && priceWrapper.classList.remove(classes.onSale);
      }

      if (soldOut) {
        priceWrapper && priceWrapper.classList.add(classes.soldOut);
      } else {
        priceWrapper && priceWrapper.classList.remove(classes.soldOut);
      }

      if (priceWrapper) {
        priceWrapper.classList.remove("visibility-hidden");

        // O card traz os dois blocos (product-prices.liquid) e o CSS mostra um
        // pela classe --on-sale. Antes o "regular" era o unico no HTML quando a
        // cor inicial nao tinha promocao e recebia o preco comparativo.
        const regularPrice = priceWrapper.querySelector(".m-price__regular .m-price-item--regular");
        const salePrice = priceWrapper.querySelector(".m-price__sale .m-price-item--sale");
        const compareAtPrice = priceWrapper.querySelector(".m-price__sale .m-price-item--regular");

        if (regularPrice) regularPrice.innerHTML = formatMoney(price, moneyFormat);
        if (salePrice) salePrice.innerHTML = formatMoney(price, moneyFormat);
        if (compareAtPrice) compareAtPrice.innerHTML = formatMoney(onSale ? compare_at_price : price, moneyFormat);

        this.updateInstallments(priceWrapper, price);
      }

      if (unit_price_measurement && unitPrice && this.currentVariant) {
        unitPrice.classList.remove("f-hidden");
        const unitPriceContent = `<span>${formatMoney(
          this.currentVariant.unit_price,
          moneyFormat
        )}</span>/<span data-unit-price-base-unit>${this.getBaseUnit()}</span>`;
        unitPrice.innerHTML = unitPriceContent;
      } else {
        unitPrice && unitPrice.classList.add("f-hidden");
      }
    }

    // Mesma conta do product-installments.liquid: Tabela Price com juros,
    // divisao simples sem, sempre arredondando o centavo para cima
    updateInstallments(priceWrapper, price) {
      const line = priceWrapper.querySelector(".m-price__installment[data-installments-count]");
      const amount = line && line.querySelector(".m-price__installment-amount");
      const count = line ? Number(line.dataset.installmentsCount) : 0;
      if (!amount || !count || !price) return;

      const rate = (Number(line.dataset.installmentsRate) || 0) / 100;
      let installment = price / count;
      if (rate > 0) {
        const compound = Math.pow(1 + rate, count);
        installment = (price * rate * compound) / (compound - 1);
      }
      amount.innerHTML = formatMoney(Math.ceil(installment), window.MinimogSettings.money_format);
    }

    getBaseUnit = () => {
      return this.currentVariant.unit_price_measurement.reference_value === 1
        ? this.currentVariant.unit_price_measurement.reference_unit
        : this.currentVariant.unit_price_measurement.reference_value +
        this.currentVariant.unit_price_measurement.reference_unit;
    };
  }

  customElements.define("pcard-swatch", ProductCardColorSwatch);
}
